const successMessageTypes = {
    MESSAGE_SENT: 'MESSAGE_SENT',
    MESSAGE_UPLOADED_SUCCESSFULLY: 'MESSAGE_UPLOADED_SUCCESSFULLY',
    ACTION_PERFORMED_SUCCESSFULLY: 'ACTION_PERFORMED_SUCCESSFULLY',
};

export default successMessageTypes;
